import addEventListenerMultiType from "./multiEventLister.js";
import isMobile from "../../plugins/is-mobile.js";

class FloatSchedule {
  constructor() {
    this.body = document.querySelector("body");
    this.scrollPosition = "";
    this.rootElement = document.querySelector(".js-float-schedule");
  }

  init() {
    if (!this.body.classList.contains("page-top")) {
      this.body.classList.remove("is-schedule-open");
    } else if (!this.body.classList.contains("page-top") || !isMobile(768)) {
      this.body.classList.add("is-schedule-open");
    }
    this.scrollEvent(this.body);
    this.attachEvent();
  }

  setScrollPosition() {
    this.scrollPosition = window.scrollY
  }

  attachEvent() {
    addEventListenerMultiType(this.rootElement, "click", (e) => {
      if (!this.body.classList.contains("is-schedule-open")) {
        this.scrollPosition = window.scrollY;
        this.body.classList.add("is-schedule-open");
        if (isMobile(767)) {
          const openStyle = new Map([
            ["position", "fixed"],
            ["top", -1 * this.scrollPosition + "px"],
            ["height", "100%"],
          ]);
          // $("#js-fullScreenMenu").fadeIn(250);
          for (const [key, value] of openStyle) {
            this.body.style[key] = value;
          }
        }
      } else {
        this.body.classList.remove("is-schedule-open");
        if (isMobile(767)) {
          const closeStyle = new Map([
            ["position", "static"],
            ["overflow", "visible"],
            ["height", "auto"],
          ]);
          // $("#js-fullScreenMenu").fadeOut(250);
          for (const [key, value] of closeStyle) {
            this.body.style[key] = value;
          }
          window.scrollTo(0, this.scrollPosition);
        }
      }
    });
  }

  scrollEvent(targetElement) {
    addEventListenerMultiType(window, "scroll", function () {
      if (window.pageYOffset >= 80) {
        targetElement.classList.remove("is-schedule-open");
      } else if(window.pageYOffset == 0) {
        if (!isMobile(768) && $('.page-top').length) {
          targetElement.classList.add("is-schedule-open");
        }
      }
    });
  }
}

const floatSchedule = new FloatSchedule();
floatSchedule.init();
